import React from 'react';
import {FeatureFlags} from '@common/types/FeatureFlags';
import {Providers} from './Providers';
import {TransitionModal} from './TransitionModal';

export type WidgetProps = {
  featureFlags: FeatureFlags;
  locale: string;
  localeApiPath: string;
  widgetPath: string;
};

const Widget = ({
  featureFlags,
  locale,
  localeApiPath,
  widgetPath
}: WidgetProps) => {
  return (
    <Providers
      featureFlags={featureFlags}
      locale={locale}
      localeApiPath={localeApiPath}
      localeModule="TmtSiirtymaModaali"
      widgetId="TmtSiirtymaModaali"
      widgetPath={widgetPath}
    >
      <TransitionModal />
    </Providers>
  );
};

export default Widget;
